<template>
  <div>
    <div class="columns is-gapless is-vcentered is-border-bottom has-bg-light is-min-height-50">
      <div class="column is-padding-left">
        {{searchs.length}} Recherche(s)
      </div>
      <div class="column is-narrow is-border-left is-self-stretched">
        <a class="button is-min-width-0 is-radiusless is-small is-light is-min-height-full has-text-grey"
          @click="openSearchModal(null)"
        >
          <span class="icon is-small"><i class="fal fa-search-plus"></i></span>
          <span>Nouvelle recherche</span>
        </a>
      </div>

    </div>
    <table class="table is-fullwidth is-marginless-bottom" v-if="searchs.length">
      <thead>
        <tr class="is-size-6">
          <th><span>Date</span></th>
          <th><span>Type de logement</span></th>
          <th><span>Adresse</span></th>
          <th><span>Type de recherche</span></th>
          <th><span>Budget max</span></th>
          <th><span>Actions</span></th>
        </tr>
      </thead>
      <contact-search-row v-for="(search, i) in searchs" :key="search.pk" :index="i" :source="search" @openSearchModal='openSearchModal' @deleteResearch='deleteResearch'></contact-search-row>
    </table>
    <div v-else class="column">Aucun critère de recherche renseigné</div>
  </div>
</template>

<script>
  import { DefaultValues } from '@/mixins'
  import ContactSearchRow from './ContactSearchRow'
  import { mapState } from 'vuex'

  export default {
    name: 'ContactSearchList',
    components: {
      ContactSearchRow
    },
    mixins: [DefaultValues],
    props: {
      sourceSearchs: {
        type: Array,
        required: true
      },
      sourceContact: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState(['quickview']),
      searchs () {
        return this.sourceSearchs
      }
    },
    watch: {
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'NEW_CONTACT_SEARCH') {
            let index = this.searchs.findIndex(x => x.pk === results.deletedPk)
            if (index === -1) {
              this.searchs.unshift(results)
            } else {
              this.searchs.splice(index, 1, results)
            }
          }
        }
      }
    },
    methods: {
      openSearchModal (item) {
        this.$store.commit('setQuickview', {mode: 'NEW_CONTACT_SEARCH', params: {contact: this.sourceContact, source: item}})
      },
      deleteResearch (id) {
        this.$swal({
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer cet élément ?',
          confirmButtonText: 'Supprimer'
        }).then(result => {
          if (result.value) {
            this.$api.contactService.deleteResearches(id).then(r => {
              const i = this.searchs.findIndex(search => search.pk === id)
              this.searchs.splice(i, 1)
              this.$notify({
                type: 'is-success',
                text: 'Suppression effectuée.'
              })
            }).catch(() => {
              this.$notify({
                type: 'is-warning',
                text: 'Suppression impossible'
              })
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contact/ContactRightPanel/ContactSearchList.vue